export default __webpack_public_path__ + "static/media/slide_1.e08f9c5d.jpg";